import { FC, useEffect, useState } from 'react';
import { useAccessToken } from 'packages/lib/utils/hooks/use-auth-data';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { purple } from '@ant-design/colors';

/** Overlaid on top of User Profile Menu button (for both internal and contractor pages) when the user's access token is loading. Prevents clicks on menu. */
export const LoadingIndicator: FC<React.PropsWithChildren<unknown>> = () => {
  const { loadingAccessToken: isLoading } = useAccessToken();
  const [showAfterDelay, setShowAfterDelay] = useState(false);
  useEffect(() => {
    if (!showAfterDelay) {
      setShowAfterDelay(true);
    }
  }, [showAfterDelay]);

  if (!isLoading || !showAfterDelay) {
    return null;
  }

  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}
    >
      <Spin
        indicator={
          <LoadingOutlined style={{ fontSize: 40, color: purple[2] }} spin />
        }
      />
    </div>
  );
};
